var map = {
	"./add-circle.svg": "66e7",
	"./add-set-circle.svg": "c8cd",
	"./add.svg": "5475",
	"./arrow-down.svg": "6ddf",
	"./arrow-long-down.svg": "6376",
	"./arrow-long-left.svg": "03f7",
	"./arrow-long-right.svg": "0199",
	"./arrow-long-up.svg": "1fa9",
	"./arrow-undo.svg": "58d2",
	"./award.svg": "024d",
	"./calendar.svg": "b886",
	"./care.svg": "0519",
	"./caret-down-small.svg": "79d9",
	"./caret-down.svg": "dac0",
	"./caret-left.svg": "d752",
	"./caret-right.svg": "d8c6",
	"./caret-up.svg": "fd27",
	"./cart-add.svg": "81b1",
	"./cart.svg": "7a6e",
	"./cat-clean-brush.svg": "04d4",
	"./cat-clean-scrub.svg": "fdf9",
	"./cat-clean-spray.svg": "93f7",
	"./cat-discount-circle-1.svg": "c984",
	"./cat-discount-circle-2.svg": "e06f",
	"./cat-furniture-armchair.svg": "e1c9",
	"./cat-furniture-bench.svg": "521a",
	"./cat-furniture-bookshelf.svg": "ac0a",
	"./cat-furniture-chairs.svg": "65c3",
	"./cat-furniture-lamp.svg": "c975",
	"./cat-furniture-parasol.svg": "cbec",
	"./cat-furniture-pillows.svg": "a030",
	"./cat-furniture-sidetable.svg": "d6bd",
	"./cat-furniture-stool.svg": "d6dc",
	"./cat-furniture-sunbed.svg": "aed1",
	"./cat-furniture-table.svg": "daf8",
	"./cat-furniture-vase.svg": "cd4d",
	"./cat-furniture-wardrobe.svg": "9b00",
	"./cat-shipment-prepare.svg": "f096",
	"./cat-shipment-ready.svg": "76a4",
	"./cat-shipment-truck.svg": "815e",
	"./cat-tasklist.svg": "c40d",
	"./check-circle.svg": "a2f9",
	"./check-small.svg": "ad60",
	"./check.svg": "47d4",
	"./deliverystate-available.svg": "6ab0",
	"./deliverystate-inweeks.svg": "25d4",
	"./deliverystate-some.svg": "2cbb",
	"./deliverystate-unavailable.svg": "ce59",
	"./diamond.svg": "684c",
	"./dots-circle.svg": "10d4",
	"./envelope-pigeon.svg": "381b",
	"./envelope.svg": "1a90",
	"./file-pdf.svg": "b199",
	"./headset.svg": "0543",
	"./heart.svg": "62bb",
	"./house.svg": "bafd",
	"./images.svg": "bb64",
	"./invisible.svg": "b96b",
	"./lamp.svg": "dd5d",
	"./leaf.svg": "953d",
	"./like.svg": "91f1",
	"./message.svg": "6e72",
	"./messages-bubble.svg": "3772",
	"./pen.svg": "11ee",
	"./play.svg": "2f36",
	"./printer.svg": "c90d",
	"./prop-chair-armrest-height.svg": "dc15",
	"./prop-chair-back-adjustable.svg": "f4e3",
	"./prop-chair-foldable.svg": "8862",
	"./prop-chair-seat-height.svg": "95dc",
	"./prop-chair-stackable.svg": "2823",
	"./prop-chair-total-depth.svg": "dd84",
	"./prop-chair-total-height.svg": "8c5a",
	"./prop-chair-total-width.svg": "89f4",
	"./prop-exclusive.svg": "8890",
	"./prop-sunbed-head-adjustable.svg": "c8e1",
	"./prop-sunbed-head-and-foot-adjustable.svg": "2b03",
	"./prop-sunbed-stackable.svg": "6ed7",
	"./prop-table-extendable.svg": "af05",
	"./prop-table-foldable.svg": "2dcc",
	"./prop-table-self-leveling.svg": "42d4",
	"./prop-table-stackable.svg": "fbe0",
	"./prop-with-rolls.svg": "4cdf",
	"./remove.svg": "399f",
	"./ribbon-star.svg": "090e",
	"./ribbon.svg": "7001",
	"./save.svg": "f1ef",
	"./screw-nuts.svg": "294c",
	"./search.svg": "b06f",
	"./settings.svg": "f765",
	"./share.svg": "ec0f",
	"./social-facebook.svg": "608b",
	"./social-instagram.svg": "364e",
	"./social-linkedin.svg": "844a",
	"./social-pinterest.svg": "9692",
	"./social-twitter.svg": "2546",
	"./social-whatsapp.svg": "4241",
	"./social-youtube.svg": "cb16",
	"./subtract.svg": "01a0",
	"./switzerland.svg": "2cec",
	"./target-user.svg": "3166",
	"./tools.svg": "8726",
	"./trash.svg": "a321",
	"./truck.svg": "9d29",
	"./user-circle.svg": "acbd",
	"./user-heart.svg": "5d46",
	"./visible.svg": "ec29",
	"./warehouse-cart.svg": "f0c3",
	"./weather-cloud-hail.svg": "519a",
	"./weather-rain.svg": "f119",
	"./zipper.svg": "e4ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22a8";